/* HomePageCommonSkeleton.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _7 = "._2lx21bp4{flex-direction:column}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "._1bsb1osq{width:100%}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Hide, Show } from '@atlaskit/primitives/responsive';
import { Skeleton } from '@atlassian/mpac-primitives';
import React from 'react';
const _4 = "._19pkyt99{margin-top:var(--_xpa7ji)}";
const _3 = "._2rko1lfe{border-radius:var(--_6bkswh)}";
const _2 = "._4t3i10e5{height:var(--_16reqip)}";
const _ = "._1bsbn9jh{width:var(--_pcenyd)}";
export const Stripe = forwardRef((_ref, __cmplr) => {
  var _cmplp$width, _cmplp$height, _cmplp$borderRadius, _cmplp$marginTop;
  let {
      as: C = Skeleton,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_pcenyd": ix((_cmplp$width = __cmplp.width) !== null && _cmplp$width !== void 0 ? _cmplp$width : '100%'),
      "--_16reqip": ix((_cmplp$height = __cmplp.height) !== null && _cmplp$height !== void 0 ? _cmplp$height : '16px'),
      "--_6bkswh": ix((_cmplp$borderRadius = __cmplp.borderRadius) !== null && _cmplp$borderRadius !== void 0 ? _cmplp$borderRadius : "var(--ds-border-radius-200, 8px)"),
      "--_xpa7ji": ix((_cmplp$marginTop = __cmplp.marginTop) !== null && _cmplp$marginTop !== void 0 ? _cmplp$marginTop : "var(--ds-space-0)")
    }),
    ref: __cmplr,
    className: ax(["_1bsbn9jh _4t3i10e5 _2rko1lfe _19pkyt99", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Stripe.displayName = 'Stripe';
}
const Container = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _1e0c1txw _2lx21bp4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const HeaderSkeleton = () => /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Stripe, {
  width: "60%"
}), /*#__PURE__*/React.createElement(Show, {
  above: "sm"
}, /*#__PURE__*/React.createElement(Stripe, {
  height: "14px",
  width: "90%",
  marginTop: "var(--ds-space-300)"
})), /*#__PURE__*/React.createElement(Hide, {
  above: "sm"
}, /*#__PURE__*/React.createElement(Stripe, {
  height: "14px",
  marginTop: "var(--ds-space-050)"
}), /*#__PURE__*/React.createElement(Stripe, {
  height: "14px",
  marginTop: "var(--ds-space-250)"
})));